var _rect, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "url(#paint0_linear_950_473)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1833 22C18.563 22 16.9589 21.65 15.3712 20.95C13.7835 20.25 12.3413 19.2519 11.0444 17.9556C9.74763 16.6593 8.74948 15.2204 8.05 13.6389C7.35052 12.0574 7.00052 10.45 7 8.81667V8H11.5889L12.3083 11.9083L10.0917 14.1444C10.3769 14.65 10.6944 15.1296 11.0444 15.5833C11.3944 16.037 11.7704 16.4583 12.1722 16.8472C12.5481 17.2231 12.9599 17.583 13.4073 17.9268C13.8548 18.2706 14.3376 18.5913 14.8556 18.8889L17.1111 16.6333L21 17.4306V22H20.1833Z",
    fill: "#FF5C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1833 22C18.563 22 16.9589 21.65 15.3712 20.95C13.7835 20.25 12.3413 19.2519 11.0444 17.9556C9.74763 16.6593 8.74948 15.2204 8.05 13.6389C7.35052 12.0574 7.00052 10.45 7 8.81667V8H11.5889L12.3083 11.9083L10.0917 14.1444C10.3769 14.65 10.6944 15.1296 11.0444 15.5833C11.3944 16.037 11.7704 16.4583 12.1722 16.8472C12.5481 17.2231 12.9599 17.583 13.4073 17.9268C13.8548 18.2706 14.3376 18.5913 14.8556 18.8889L17.1111 16.6333L21 17.4306V22H20.1833Z",
    fill: "url(#paint1_linear_950_473)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_950_473",
    x1: 1.77269e-7,
    y1: 14.459,
    x2: 28,
    y2: 14.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBB24B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A4D03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_950_473",
    x1: 7,
    y1: 14.9795,
    x2: 21,
    y2: 14.9795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBB24B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A4D03"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneimg);
export default __webpack_public_path__ + "static/media/phoneimg.81df2ff1ad6b300f711245f257751855.svg";
export { ForwardRef as ReactComponent };